export default __webpack_public_path__ + "static/media/lessThanIcon.a20f7b41.svg";